import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import React from 'react';

function getPad({ size }) {
    switch (size) {
        case 'md':
            return '30px';

        case 'sm':
        default:
            return '20px';
    }
}

const Icon = styled.div`
    .icon {
        width: 18px;
        height: 18px;
    }

    .icon-times {
        width: 27px;
        height: 27px;
        cursor: pointer;
        margin-right: -5px;
    }
`;

const Header = styled.div`
    box-shadow: ${({ theme }) => `0 1px 1px 0 ${theme.inputBorder}`};
    background: ${({ theme }) => theme.primary.bg};
    color: ${({ theme }) => theme.bodyText};
    justify-content: space-between;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: 0 ${getPad};
    margin-bottom: 2px;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    display: flex;
    cursor: move;
    height: 55px;
`;
const Title = styled.div`
    text-transform: uppercase;
    color: ${({ theme }) => theme.titleText};
`;

const ModalHeader = React.forwardRef(
    ({ children, close, ...restOfProps }, ref) => {
        return (
            <Header ref={ref} {...restOfProps}>
                <Icon>
                    <FontAwesomeIcon className="icon" icon={['far', 'cog']} />
                </Icon>
                <Title>{children}</Title>
                <Icon onClick={close}>
                    <FontAwesomeIcon
                        className="icon icon-times"
                        icon={['fal', 'times']}
                    />
                </Icon>
            </Header>
        );
    }
);

export default React.memo(ModalHeader);
